import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const simulatedHarvests = [
  { id: 1, culture: 'Soja', plantDate: '2023-01-10', harvestDate: '2023-05-20', productivity: 3.2, area: 50, cost: 5000, revenue: 8000 },
  { id: 2, culture: 'Milho', plantDate: '2022-12-15', harvestDate: '2023-04-25', productivity: 4.0, area: 60, cost: 6000, revenue: 9000 },
  { id: 3, culture: 'Café', plantDate: '2022-06-01', harvestDate: '2022-10-10', productivity: 2.5, area: 40, cost: 4500, revenue: 7000 },
];

const HarvestHistory = () => {
  const [harvests, setHarvests] = useState(simulatedHarvests);
  const [showModal, setShowModal] = useState(false);

  const handleAddHarvest = () => {
    // Aqui podemos abrir um modal ou formulário para adicionar uma nova safra
    setShowModal(true);
  };

  // Gráfico de produtividade ao longo do tempo
  const chartData = harvests.map((harvest) => ({
    name: harvest.culture,
    produtividade: harvest.productivity,
  }));

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>Histórico de Safra</Typography>
      
      {/* Tabela de Histórico de Safra */}
      <TableContainer component={Paper} sx={{ marginBottom: '30px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Cultura</TableCell>
              <TableCell>Data de Plantio</TableCell>
              <TableCell>Data de Colheita</TableCell>
              <TableCell>Produtividade (ton/ha)</TableCell>
              <TableCell>Área (ha)</TableCell>
              <TableCell>Receita</TableCell>
              <TableCell>Custo</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {harvests.map((harvest) => (
              <TableRow key={harvest.id}>
                <TableCell>{harvest.culture}</TableCell>
                <TableCell>{harvest.plantDate}</TableCell>
                <TableCell>{harvest.harvestDate}</TableCell>
                <TableCell>{harvest.productivity}</TableCell>
                <TableCell>{harvest.area}</TableCell>
                <TableCell>{harvest.revenue}</TableCell>
                <TableCell>{harvest.cost}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="primary" size="small">Ver Detalhes</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Botão para Adicionar Safra */}
      <Button variant="contained" color="primary" onClick={handleAddHarvest}>Adicionar Safra</Button>

      {/* Gráfico de Produtividade */}
      <Box sx={{ marginTop: '30px' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '10px' }}>Produtividade ao Longo das Safras</Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="produtividade" stroke="#8884d8" />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default HarvestHistory;
